




import Vue from 'vue';

export default Vue.component('Piece', {
  props: ['colour', 'small']
});
